module.exports = __webpack_public_path__ + "img/csv.dee6e254.png";